module.exports = __webpack_public_path__ + "img/tips3.fc8b6d7b.png";